<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>

    <div v-if="!modoEdicao">
        <div class="form-edit-page row row-space">
            <EstabelecimentoSelect :ckAddTodos="true" v-model:idSelecionado="estabelecimentoSelecionado" />
            <div class="form-item">
                <label class="label-caption" for="nmPesquisa">Pesquisar</label>
                <input type="text" v-model="nmPesquisa" id="nmPesquisa" maxlength="80" v-uppercase />
            </div>
            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>

        <table>
            <thead>
                <tr>
                    <th class="col-width-char10">Data</th>
                    <th class="col-width-char40">Estabelecimento</th>
                    <th>Nome Documento</th>
                    <th class="col-width-char10">Validade</th>
                    <th class="col-width-char30">Situação</th>
                    <th class="col-width-char10">Ações</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td class="col-width-char10 center">{{ formatDateFromJson(obj.dtanexo) }}</td>
                    <td class="col-width-char40">{{ obj.nmestabelecimento }}</td>
                    <td>{{ obj.nmdoc }}</td>
                    <td class="col-width-char10 center">{{ formatDateFromJson(obj.dtvalidade) }}</td>
                    <td class="col-width-char30">{{ obj.situacaonm }}</td>
                    <td class="col-width-char10"><div class="row-start">
                        <button class="btn-icon btn-icon--pdf" @click="lerAnexo(obj)"></button>
                        <button v-if="obj.situacao === 1" class="btn-icon btn-icon--checkMark" @click="openAnalise(obj)"></button>
                    </div></td>
                </tr>
            </tbody>
        </table>
    </div>


    <div v-if="showAnalise" class="modal-overlay">
        <div class="modal-content">
            <h4>Análise de Documentação</h4>
            <form>
                <div class="form-group">
                    <div class="form-item">
                        <label class="label-caption">Data de Validade:</label>
                        <input type="date" v-model="dtValidade" required />
                    </div>
                </div>

                <div class="form-group">
                    <div class="form-item">
                        <label class="label-caption">Justificativa</label>
                        <textarea v-model="obsAnalise" maxlength="1000" rows="5" style="resize: none;" required/>
                    </div>
                </div>

                <div class="buttons form-group">
                    <button type="button" class="btn-confirm" @click="salvarAnalise('S')">APROVAR</button>
                    <button type="button" class="btn-cancel" @click="salvarAnalise('N')">NÃO APROVAR</button>
                </div>

                <div class="buttons">
                    <button @click="showAnalise = false">SAIR</button>
                </div>
            </form>
        </div>
    </div>
</template>


<script setup>
import { ref } from 'vue';
import { genericPost, genericPut } from '@/funcoes/api';
import { globalStore } from '@/globals';
import { formatDateFromJson, strDataHoraAtual } from '@/funcoes/utils';
import EstabelecimentoSelect from '../selects/EstabelecimentoSelect.vue';

const emit = defineEmits(['close']);
const dtValidade = ref(null);
const estabelecimentoSelecionado = ref(null);
const isLoading = ref(false);
const lsDados = ref([]);
const msgAlerta = ref(null);
const nmPesquisa = ref(null);
const objSelecionado = ref(null);
const obsAnalise = ref('');
const showAnalise = ref(false);

const closeForm = () => {emit('close');}

const lerAnexo = async(obj) => {
    try{
        isLoading.value = true;
        const dados = {id: obj.id};
        const req = await genericPost('/main/anexo_base64', dados);
        const pdfBase64 = req.anexo;
        const pdfWindow = window.open("");
        const iframe = pdfWindow.document.createElement("iframe");
        iframe.style.width = "100%";
        iframe.style.height = "100%";
        iframe.src = "data:application/pdf;base64," + encodeURIComponent(pdfBase64);
        pdfWindow.document.body.appendChild(iframe);
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
};

const lerDados = async() => {
    try{
        isLoading.value = true;
        const req = await genericPost('/listas/anexos', {
            idep: globalStore.idep,
            idsim: globalStore.idsim,
            idestabelecimento: (estabelecimentoSelecionado.value ? estabelecimentoSelecionado.value.id : 0),
            intparam1: 2,
            nmpesquisar: nmPesquisa.value});
        lsDados.value = req;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}

const openAnalise = (obj) => {
    objSelecionado.value = obj;
    dtValidade.value = obj.dtvalidade;
    obsAnalise.value = null;
    showAnalise.value = true;
}

const salvarAnalise = async(aprovadoSN) => {
    if (!dtValidade.value){alert('Necessário informar data de validade'); return;}
    if (!obsAnalise.value){alert('Necessário informar justificativa'); return;}
    try{
        try {
            const dados = {
                id: objSelecionado.value.id,
                dhanalise : strDataHoraAtual(),
                idloginanalise: globalStore.idlogin,
                iduanalise: globalStore.id,
                obsanalise: obsAnalise.value,
                homologado: aprovadoSN
            };
            const ret = await genericPut('/cad/anexo', dados);
            if (ret.bolok == 0){
                msgAlerta.value = `ATENÇÃO: ${ret.erro}`;
            }else{
                await lerDados();
                showAnalise.value = false;
            }
        } catch (error) {
            msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value = false;}
}
</script>